module.exports = __webpack_public_path__ + "static/media/hip_flask.bb89ac50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hip_flask.png
// module id = 114
// module chunks = 0